export { TermsAndConditions } from './pages/TermsAndConditions';
export { PersonalDataProtection } from './pages/PersonalDataProtection';
export { OnlineSecurity } from './pages/OnlineSecurity';
export { PaymentConditions } from './pages/PaymentConditions';
export { ConsumerInformation } from './pages/ConsumerInformation';
